import { Check } from 'lucide-react';

interface FilterOptionProps {
  value: string | null | undefined;
  isSelected: boolean;
}

function FilterOptionWrapper({
  isSelected,
  children,
}: {
  isSelected: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      {children}
    </div>
  );
}

export function MCPPublisherFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <FilterOptionWrapper isSelected={isSelected}>
      <span className="text-xs text-muted-foreground break-words whitespace-normal leading-snug">
        {value ?? '—'}
      </span>
    </FilterOptionWrapper>
  );
}

export function MCPVersionFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <FilterOptionWrapper isSelected={isSelected}>
      <span className="text-xs text-muted-foreground">{value ?? '—'}</span>
    </FilterOptionWrapper>
  );
}
